const benefits = [
  { icon: "ri-focus-3-line", label: "Built around your exact processes" },
  { icon: "ri-bar-chart-grouped-line", label: "Scales with your business" },
  { icon: "ri-delete-back-line", label: "Eliminates inefficiencies from generic tools" },
  { icon: "ri-eye-line", label: "Provides full visibility and control" },
  { icon: "ri-flashlight-line", label: "Designed for real-world execution" },
];

export default function WhyBespoke() {
  return (
    <section className="py-12 md:py-16">
      <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-16">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3">Why Bespoke</h2>
          <p className="text-base text-silver-300 mb-8 max-w-2xl">
            Custom software gives you advantages off-the-shelf tools simply cannot match.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {benefits.map((b) => (
              <div key={b.label} className="glass-card p-5 flex items-start gap-3 group">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-graphite-800 group-hover:bg-emerald-accent/10 transition-colors flex-shrink-0">
                  <i className={`${b.icon} text-emerald-accent group-hover:scale-110 transition-transform duration-300`} />
                </div>
                <span className="text-sm font-medium text-silver-200 pt-1.5 group-hover:text-emerald-soft transition-colors duration-300">{b.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}